module.exports = __webpack_public_path__ + "static/index/img/baikal-200.2fb53313.jpg";